export interface StackedSymbol {
    symbolType: number;
    symbolsAmount: number;
}